import { render, staticRenderFns } from "./TheMenuItem.vue?vue&type=template&id=d3f9f2aa&"
import script from "./TheMenuItem.vue?vue&type=script&lang=js&"
export * from "./TheMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports